<template>
    <div
        class="visualization expenses-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <h3>{{ max }} Mayores Proveedores/Receptores</h3>
        <div class="row">
            <div class="col-sm-10">
                <el-radio-group v-model="periodo">
                    <el-radio-button
                        v-for="p in periodos"
                        :key="p"
                        :label="p"
                    ></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-sm-2 text-right">
                <div class="mode-selector" v-show="beneficiario === null">
                    <span class="title">Ver como</span>
                    <div class="view-buttons">
                        <el-tooltip content="Gráfico">
                            <a
                                href="#"
                                @click.prevent="mode = 'chart'"
                                :class="{ active: mode === 'chart' }"
                            >
                                <i class="material-icons">dashboard</i>
                            </a>
                        </el-tooltip>
                        <el-tooltip content="Tabla">
                            <a
                                href="#"
                                @click.prevent="mode = 'table'"
                                :class="{ active: mode === 'table' }"
                            >
                                <i class="material-icons">view_list</i>
                            </a>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="beneficiario === null">
            <div>
                <el-slider
                    range
                    v-model="slider"
                    @change="changeRange"
                    :max="max"
                    :step="1"
                    :format-tooltip="formatTooltip"
                ></el-slider>
                <div class="row">
                    <div class="col-6">Ver menos</div>
                    <div class="col-6 text-right">Ver más</div>
                </div>
            </div>

            <br />

            <bubble-chart
                v-show="mode === 'chart'"
                :data="filteredData"
                :dimensions="dimensions"
                @detail-clicked="detailClicked"
            ></bubble-chart>
            <table-chart
                :height="510"
                :data="filteredData"
                v-show="mode === 'table'"
                @detail-clicked="detailClicked"
            ></table-chart>
        </div>
        <div v-show="beneficiario !== null">
            <div>
                <a href="#" @click.prevent="beneficiario = null"
                    >< Volver a la visualización</a
                >
            </div>
            <expenses-detail-visualization
                :where="detailWhere"
                ref="detailViz"
            ></expenses-detail-visualization>
        </div>

        <visualization-footer :url="this.url"></visualization-footer>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import BubbleChart from '../Charts/Bubble';
import TableChart from '../Charts/Table';
import ExpensesDetailVisualization from './ExpensesDetail';
import VisualizationFooter from './Common/Footer';

export default {
    data: function() {
        return {
            periodo: this.$store.state.defaultYear,
            periodos: [],
            slider: [0, 0],
            range: [0, 0],
            loading: false,
            data: [],
            mode: 'chart',
            dimensions: { ordinal: ['beneficiario'] },
            beneficiario: null,
            sum: 0
        };
    },
    props: ['where'],
    components: {
        BubbleChart,
        TableChart,
        ExpensesDetailVisualization,
        VisualizationFooter
    },
    watch: {
        max: function() {
            this.slider = this.range = [0, Math.min(this.max, 100)];
        },
        periodo: function(value) {
            this.$store.commit('setDefaultYear', value);
            this.refreshData();
        }
    },
    computed: {
        max: function() {
            return Math.min(500, this.data.length);
        },
        computedData: function() {
            return _(this.data)
                .orderBy('sum', 'desc')
                .value();
        },
        filteredData: function() {
            return _(this.computedData)
                .slice(this.range[0], this.range[1])
                .shuffle()
                .value();
        },
        computedWhere: function() {
            const where = _.merge(_.clone(this.where), {
                periodo: this.periodo,
                proveedor: true,
                intraestado: false
            });

            /*
                const where = {
                    periodo: this.periodo,
                    proveedor: true,
                    partida: this.institution.partida
                };
                if(this.institution.capitulo)
                    where.capitulo = this.institution.capitulo;
                if(this.institution.area)
                    where.area = this.institution.area;
                    */

            return where;
        },
        detailWhere: function() {
            return _.assign(_.clone(this.computedWhere), {
                beneficiario: this.beneficiario
            });
        },
        url: function() {
            return (
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['beneficiario']) +
                '&where=' +
                JSON.stringify(this.computedWhere) +
                '&order-by=["sum","desc"]&limit=500'
            );
        }
    },
    methods: {
        assign: _.assign,
        clone: _.clone,
        numeral: numeral,
        formatTooltip(d) {
            return numeral(d).format('0,0');
        },
        detailClicked: function(n) {
            this.beneficiario = n.beneficiario;
            //this.$nextTick(()=>{
            //    this.$refs.detailViz.refreshData();
            //});
        },
        changeRange: function(value) {
            this.range = value;
        },
        refreshData: function() {
            this.loading = true;
            Promise.all([
                axios.get(this.url),
                axios.get('/api/v1/data/pagos', {
                    params: {
                        where: JSON.stringify(this.computedWhere),
                        sum: JSON.stringify('devengo')
                    }
                })
            ]).then(responses => {
                this.loading = false;
                const data = responses[0].data;
                const sum = responses[1].data[0].sum;
                console.log(responses[1]);

                this.data = data.map(d => {
                    return _.merge(_.clone(d), { percentage: d.sum / sum });
                });
            });
        }
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Providers.vue